import React, { lazy } from 'react';
import { XIcon, MinimizeIcon } from 'lucide-react';
interface SpotifyPlayerProps {
  onClose: () => void;
}
const SpotifyPlayer: React.FC<SpotifyPlayerProps> = ({
  onClose
}) => {
  return <div className="bg-black bg-opacity-90 border-t border-pink-600 p-4 shadow-lg shadow-pink-500/20" data-id="element-563">
      <div className="container mx-auto" data-id="element-564">
        <div className="flex justify-between items-center mb-2" data-id="element-565">
          <h3 className="text-xl font-mono text-pink-400" data-id="element-566">
            FABRIC REALITY • SPOTIFY
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" data-id="element-567">
            <MinimizeIcon size={20} data-id="element-568" />
          </button>
        </div>
        <div className="w-full max-w-4xl mx-auto" data-id="element-569">
          <iframe style={{
          borderRadius: '12px'
        }} src="https://open.spotify.com/embed/artist/1eBlIKgOfnWYuzUVRNpmNT?utm_source=generator&theme=0" width="100%" height="352" frameBorder="0" allowFullScreen allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Fabric Reality Spotify Player" data-id="element-570"></iframe>
        </div>
      </div>
    </div>;
};
export default SpotifyPlayer;